import { Box } from 'braid-design-system';
import { useState, type FC } from 'react';
import ReactConfetti from 'react-confetti';

interface ConfettiProps {
  isConfettiRunning: boolean;
  stopConfetti: () => void;
  top?: number;
  height?: number;
  width?: number;
  left?: number;
}

const colours = ['#FDC221', '#8BDEC5', '#98C9F1', '#E60278'];
const upDuration = 1500;

export const Confetti: FC<ConfettiProps> = ({
  top = 0,
  left = 0,
  height = 400,
  width = 400,
  isConfettiRunning,
  stopConfetti,
}) => {
  const [direction, setDirection] = useState<'up' | 'down'>('up');

  const upWidth = width / 5;
  const numberOfPieces = Math.floor(upWidth * 1.25);

  const drawShape = (ctx: CanvasRenderingContext2D) => {
    const shape = Math.random(); // Randomly decide shape type

    ctx.beginPath();
    if (shape < 0.5) {
      ctx.rect(-3, -3, 10, 10);
    } else {
      ctx.arc(0, 0, 5, 0, 2 * Math.PI);
    }
    ctx.fill();
  };

  if (direction === 'up') {
    return (
      <Box
        data={{ testid: 'confetti' }}
        position="absolute"
        style={{ left, top, height: 0, width: 0 }}
        aria-hidden
      >
        {/* Left confetti */}
        <ReactConfetti
          numberOfPieces={isConfettiRunning ? numberOfPieces / 2 : 0}
          colors={colours}
          width={width}
          height={height}
          recycle={false}
          tweenDuration={upDuration}
          gravity={-0.25}
          initialVelocityX={{
            min: 0,
            max: 4,
          }}
          confettiSource={{
            y: height,
            x: left,
            w: upWidth,
            h: 0,
          }}
          onConfettiComplete={(confetti) => {
            setDirection('down');
            confetti?.reset();
          }}
          drawShape={drawShape}
        />
        {/* Right confetti */}
        <ReactConfetti
          numberOfPieces={isConfettiRunning ? numberOfPieces / 2 : 0}
          colors={colours}
          width={width}
          height={height}
          recycle={false}
          tweenDuration={upDuration}
          gravity={-0.25}
          initialVelocityX={{
            min: -4,
            max: 0,
          }}
          confettiSource={{
            y: height,
            x: width - upWidth,
            w: upWidth,
            h: 0,
          }}
          onConfettiComplete={(confetti) => {
            confetti?.reset();
          }}
          drawShape={drawShape}
        />
      </Box>
    );
  }

  return (
    <Box
      position="absolute"
      style={{ left, top, height: 0, width: 0 }}
      aria-hidden
    >
      <ReactConfetti
        numberOfPieces={isConfettiRunning ? numberOfPieces : 0}
        colors={colours}
        width={width}
        gravity={0.1}
        initialVelocityY={-3}
        recycle={false}
        tweenDuration={2000}
        onConfettiComplete={(confetti) => {
          stopConfetti();
          confetti?.reset();
        }}
        drawShape={drawShape}
      />
    </Box>
  );
};
